<template>
  <section id="businessContactInfo">
    <div class="container">
      <div class="header">
        <h5>Business</h5>
        <CancelButton></CancelButton>
      </div>
      <form action="#" autocomplete="off">
        <h5>Who can we contact at {{companyName}}?</h5>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="contactPerson">
                Contact Person
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="contactPerson"
                id="contactPerson"
                class="input"
                type="text"
                required
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="email">
                Email Address
                <span>*</span>
              </label>
              <input
                v-validate="'required|email'"
                v-model="email"
                id="email"
                class="input"
                type="email"
                required
              >
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <div class="control">
              <label for="mobile">
                Mobile Number
                <span>*</span>
              </label>
              <input
                v-validate="'required'"
                v-model="mobile"
                id="mobile"
                class="input"
                type="tel"
                v-mask="'### ### ####'"
                required
              >
            </div>
          </div>
          <div class="column is-one-third">
            <div class="control">
              <label for="workNum">
                Work Phone Number
                
              </label>
              <input
                
                v-mask="'### ### ####'"
                v-model="workNum"
                id="workNum"
                class="input"
                type="tel"
                required
              >
            </div>
          </div>
        </div>
      </form>

      <div class="actions">
        <button @click="back()" class="button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="toBusinessAddress()" class="button is-danger">Continue</button>
      </div>
    </div>
  </section>
</template>

<script>
import CancelButton from "../../components/actions/CancelButton";
import alertify from "alertifyjs";
import { mask } from "vue-the-mask";
export default {
  name: "businessContactInfo",
  directives: { mask },
  data() {
    return {
      contactPerson: null,
      email: null,
      mobile: null,
      workNum: null
    };
  },
  components: {
    CancelButton
  },
  methods: {
    toBusinessAddress() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false;
          alertify.error("Please check all fields are filled in correctly.");
        } else {
          this.$store.commit("SAVE_BUSINESS_CONTACT", {
            contactPerson: this.contactPerson,
            email: this.email,
            mobile: this.mobile,
            workNum: this.workNum
          });
          this.$router.push("/businessaddress");
        }
      });
    },
    back() {
      document.body.classList.add("transitionBack");

      this.$router.go(-1);

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    }
  },
  computed: {
    companyName() {
      return this.$store.state.business.info.tradingName;
    }
  },
  mounted() {
    this.contactPerson = this.$store.state.business.contact.contactPerson
    this.email = this.$store.state.business.contact.email
    this.mobile = this.$store.state.business.contact.mobile
    this.workNum = this.$store.state.business.contact.workNum
  }
};
</script>
